import { Route, Routes } from 'react-router-dom';
import './App.css';
import FileUploadSuccess from './components/FileUploadSuccess';
import ListUpload from './components/ListUpload';
import PrivateOutlet from './components/PrivateOutlet';
import AuthProvider from './context/AuthProvider';
import AdminDashboard from './pages/AdminDashboard';
import EditPreviousUploadedItem from './pages/EditPreviousUploadedItem';
import Home from './pages/Home';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import PreviousUploadedList from './pages/PreviousUploadedList';
import VendorItems from './pages/VendorItems';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='*' element={<NotFound />} />

        <Route path='/' element={<PrivateOutlet />}>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/admin-dashboard' element={<AdminDashboard />} />
          <Route exact path='/list-upload' element={<ListUpload />} />
          <Route exact path='/file-upload-success' element={<FileUploadSuccess />} />
          <Route exact path='/vendor-items' element={<VendorItems />} />
          <Route exact path='/previous-uploaded-list' element={<PreviousUploadedList />} />
          <Route exact path='/edit-previous-uploaded-item/:id' element={<EditPreviousUploadedItem />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
